<!--
  Audit UI/UX (feedback utente): banner di stato e stepper erano elementi
  "sciolti" sullo sfondo grigio della pagina, senza nessun guscio a
  contenerli - non coerente con lo stile reale della piattaforma. Ricostruito
  con lo stesso dashboard-card gia' usato nella dashboard di gestione e nella
  tab Team, cosi' l'intero wizard vive in un'unica card bianca invece di
  pezzi indipendenti.

  Ridisegno "form unico" (feedback utente: "non deve essere a stepper ma [...]
  un unico grande form cosi' permette al clinico di prendere visione ai
  singoli file e restituire in maniera piu' flessibile"): rimosso
  <mat-stepper> - anagrafica/dati fiscali/documenti vivono tutti nella stessa
  pagina scorrevole, nessun passo obbligato.

  Feedback utente: "il form [...] deve essere in un container" - container-fluid
  (piena larghezza, bordo a bordo) al posto di container qui era sbagliato: a
  differenza della dashboard/gestione manager (che vivono dentro il .container
  gia' presente in survey-details-page.component.html), questa e' una pagina
  instradata a se stante, quindi il proprio contenitore e' l'UNICO vincolo di
  larghezza - stesso schema gia' in uso in survey-response-page.component.html
  per il caso "rispondente identificato" (container-fluid riservato li' al solo
  caso anonimo, pensato per riempire tutto lo schermo).
-->
<div class="clinical-onboarding-wizard container mb-5">
  @if (loading) {
    <div class="row">
      <mat-progress-bar mode="indeterminate" class="custom-loader"></mat-progress-bar>
    </div>
  } @else {
    <div class="dashboard-card shadow-sm my-4 border-primary">
      <div class="card-header bg-white border-bottom p-4 status-banner" [style.borderLeftColor]="macroStatusMeta[macroStatus]?.color">
        <mat-icon class="status-banner-icon" [style.color]="macroStatusMeta[macroStatus]?.color">{{ macroStatusMeta[macroStatus]?.icon || 'info' }}</mat-icon>
        <div class="status-banner-text">
          <h4 class="dashboard-card-title mb-1">{{ 'components.clinical-onboarding.wizard.title' | translate }}</h4>
          <p class="mb-0 text-muted">
            {{ 'components.clinical-onboarding.wizard.current-status' | translate }}:
            <strong [style.color]="macroStatusMeta[macroStatus]?.color">
              {{ macroStatusMeta[macroStatus]?.i18nKey | translate }}
            </strong>
            @if (manualOverride) {
              <span class="override-chip">{{ 'components.clinical-onboarding.wizard.manual-override' | translate }}</span>
            }
          </p>
        </div>
        @if (canGoToSurveyResponse) {
          <button mat-raised-button color="primary" (click)="goToSurveyResponse()">
            {{ 'components.clinical-onboarding.wizard.go-to-survey' | translate }}
          </button>
        } @else if (eligibleButNotImported) {
          <span class="waiting-import-hint">{{ 'components.clinical-onboarding.wizard.waiting-import-hint' | translate }}</span>
        }
      </div>

      <div class="card-body p-4">
        <h6 class="section-title">
          <mat-icon class="mr-2">work</mat-icon>
          {{ 'components.clinical-onboarding.wizard.step-employer' | translate }}
        </h6>
        <form [formGroup]="form">
          <div class="row">
            <div class="col-md-3">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ 'components.clinical-onboarding.wizard.field-title' | translate }}</mat-label>
                <input matInput formControlName="title" maxlength="50">
              </mat-form-field>
            </div>
            <div class="col-md-9">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ 'components.clinical-onboarding.wizard.field-employer-type' | translate }}</mat-label>
                <mat-select formControlName="employer_type">
                  <mat-option [value]="EmployerType.PUBLIC">{{ 'components.clinical-onboarding.employer-type.public' | translate }}</mat-option>
                  <mat-option [value]="EmployerType.PRIVATE">{{ 'components.clinical-onboarding.employer-type.private' | translate }}</mat-option>
                  <mat-option [value]="EmployerType.NONE">{{ 'components.clinical-onboarding.employer-type.none' | translate }}</mat-option>
                </mat-select>
                <mat-error>{{ fieldError('employer_type') }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          @if (isEmployerPublic) {
            <div class="row">
              <div class="col-12">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                  <mat-label>{{ 'components.clinical-onboarding.wizard.field-employer-name' | translate }}</mat-label>
                  <input matInput formControlName="employer_name" maxlength="255">
                  <mat-error>{{ fieldError('employer_name') }}</mat-error>
                </mat-form-field>
              </div>
            </div>
            <p class="hint-text">{{ 'components.clinical-onboarding.wizard.public-employer-hint' | translate }}</p>
          }

          <h6 class="section-title">
            <mat-icon class="mr-2">account_balance</mat-icon>
            {{ 'components.clinical-onboarding.wizard.step-fiscal' | translate }}
          </h6>
          <div class="row">
            <div class="col-md-6">
              <!-- Stesso fix di modal-edit-clinician-data (feedback utente: "il
                   testo si sovrappone") - subscriptSizing di default (fixed)
                   lascia sotto il campo una sola riga: questo hint e' piu' lungo
                   e senza "dynamic" sfora sulla riga successiva. -->
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ 'components.clinical-onboarding.wizard.field-iban' | translate }}</mat-label>
                <input matInput formControlName="iban" placeholder="IT00X0000000000000000000000">
                @if (!canEditBankFiscalData) {
                  <mat-hint>{{ 'components.clinical-onboarding.wizard.locked-hint' | translate }}</mat-hint>
                }
                <mat-error>{{ fieldError('iban') }}</mat-error>
              </mat-form-field>
            </div>
            <div class="col-md-6">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ 'components.clinical-onboarding.wizard.field-tax-code' | translate }}</mat-label>
                <input matInput formControlName="tax_code" maxlength="16">
                <mat-error>{{ fieldError('tax_code') }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                <mat-label>{{ 'components.clinical-onboarding.wizard.field-fiscal-regime' | translate }}</mat-label>
                <mat-select formControlName="fiscal_regime">
                  <mat-option [value]="FiscalRegime.OCCASIONAL_SIMPLE">{{ 'components.clinical-onboarding.fiscal-regime.occasional-simple' | translate }}</mat-option>
                  <mat-option [value]="FiscalRegime.INPS_SEPARATE_MANAGEMENT">{{ 'components.clinical-onboarding.fiscal-regime.inps-separate-management' | translate }}</mat-option>
                  <mat-option [value]="FiscalRegime.VAT_NUMBER">{{ 'components.clinical-onboarding.fiscal-regime.vat-number' | translate }}</mat-option>
                </mat-select>
                <mat-error>{{ fieldError('fiscal_regime') }}</mat-error>
              </mat-form-field>
            </div>
          </div>
          @if (saveAttempted && invalidFields.length > 0) {
            <div class="form-errors-summary" role="alert">
              <strong>{{ 'components.clinical-onboarding.wizard.errors-summary-title' | translate }}</strong>
              <ul>
                @for (item of invalidFields; track item.label) {
                  <li><strong>{{ item.label }}:</strong> {{ item.message }}</li>
                }
              </ul>
            </div>
          }
          <div class="wizard-actions">
            <button mat-raised-button color="primary" [disabled]="saving || !canEditBankFiscalData" (click)="save()" type="button">
              {{ 'generic.buttons.save' | translate }}
            </button>
          </div>
        </form>

        <hr class="section-divider">

        <h6 class="section-title">
          <mat-icon class="mr-2">description</mat-icon>
          {{ 'components.clinical-onboarding.wizard.step-documents' | translate }}
        </h6>
        <p class="hint-text">{{ 'components.clinical-onboarding.wizard.documents-hint' | translate }}</p>

        @if (documents.length === 0) {
          <p class="hint-text">{{ 'components.clinical-onboarding.wizard.no-documents-yet' | translate }}</p>
        } @else {
          <div class="documents-list">
            @for (document of documents; track document.id) {
              <div class="document-row flex-wrap">
                <mat-icon class="document-icon">description</mat-icon>
                <div class="document-info-text">
                  <div class="document-type">{{ document.title }}</div>
                  <div class="document-hint text-muted small">
                    @if (!document.can_view) {
                      {{ 'components.clinical-onboarding.wizard.document-not-ready-yet' | translate }}
                    } @else if (document.requires_upload) {
                      {{ 'components.clinical-onboarding.wizard.document-hint-requires-upload' | translate }}
                    } @else {
                      {{ 'components.clinical-onboarding.wizard.document-hint-view-only' | translate }}
                    }
                  </div>
                </div>

                <app-clinical-onboarding-document-status-badge [status]="document.status"></app-clinical-onboarding-document-status-badge>

                @if (document.can_view) {
                  <!-- Feedback utente: l'icona sola (senza guscio di bottone) accanto al
                       titolo non si capiva fosse cliccabile - un mat-stroked-button
                       color="primary" esplicito, stesso stile gia' in uso per "Carica
                       file" accanto, coerente con l'occhio color primario gia' richiesto
                       per la dashboard del gestore. -->
                  <button mat-stroked-button color="primary" (click)="viewDocument(document)">
                    <mat-icon class="mr-1">visibility</mat-icon>
                    {{ 'generic.view' | translate }}
                  </button>
                }

                @if (document.can_view && document.requires_upload) {
                  @if (document.returned_file_name) {
                    <!-- Feedback utente: "non c'e' il tracciamento dell'evento di
                         scaricamento del file da parte del clinico" - il clinico puo'
                         riaprire il file che ha gia' restituito, per controllare cosa
                         ha effettivamente inviato (tracciato lato backend). -->
                    <button mat-stroked-button (click)="viewDocument(document, 'return')">
                      <mat-icon class="mr-1">visibility</mat-icon>
                      {{ 'components.clinical-onboarding.wizard.view-returned-file' | translate }}
                    </button>
                  }
                  @if (!document.is_immutable) {
                    <input type="file" accept=".pdf,.jpg,.jpeg,.png" #returnFileInput hidden (change)="onDocumentFileSelected(document, $event)">
                    <button mat-stroked-button color="primary" [disabled]="uploadingDocumentId === document.id" (click)="returnFileInput.click()">
                      @if (uploadingDocumentId === document.id) {
                        <mat-icon class="spin mr-1">autorenew</mat-icon>
                      } @else {
                        <mat-icon class="mr-1">upload</mat-icon>
                      }
                      {{ (document.returned_file_name
                        ? 'components.clinical-onboarding.wizard.replace-returned-file'
                        : 'components.clinical-onboarding.wizard.upload-returned-file') | translate }}
                    </button>
                  }
                }

                @if (document.status === 'ANOMALY' && document.anomaly_reason) {
                  <p class="anomaly-reason w-100 mb-0">
                    <mat-icon class="mr-1">error_outline</mat-icon>
                    {{ document.anomaly_reason }}
                  </p>
                }
              </div>
            }
          </div>
        }
      </div>
    </div>
  }
</div>
